module.exports = __webpack_public_path__ + "assets/img/UsedCouponMark.e03bd04b.png";